import styled, { css } from "styled-components";

export const MoreDetailsContent = styled.div`
  width: 100%;
  display: flex;
  overflow-y: hidden;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    padding-bottom: 1.25rem;
    width: 100%;
    border-bottom: 1px solid rgba(82, 82, 82, 0.64);

    img {
      cursor: pointer;
    }
  }
`;

type ReportContentProps = {
  haveEmptyPictures: boolean;
};

export const ReportContent = styled.div<ReportContentProps>`
  width: 100%;
  display: grid;
  overflow-y: auto;

  ${({ haveEmptyPictures }) =>
    haveEmptyPictures &&
    css`
      width: 100%;
      display: grid;
      grid-template-columns: 3fr;
      height: 29.75rem;
      overflow-y: auto;
    `}
`;

export const VehicleInformation = styled.div`
  width: 100%;
`;

export const InfoContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 2rem;
`;

export const WaitingTitle = styled.h3`
  margin-bottom: 1.5rem;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;

  &::before {
    content: "•";
    color: var(--primary);
    margin-right: 0.75rem;
  }
`;

export const NotFoundTitle = styled.h3`
  margin-bottom: 1.5rem;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;

  &::before {
    content: "•";
    color: var(--red);
    margin-right: 0.75rem;
  }
`;

export const FoundTitle = styled.h3`
  margin-bottom: 1.5rem;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;

  &::before {
    content: "•";
    color: var(--green);
    margin-right: 0.75rem;
  }
`;

export const Information = styled.div`
  display: grid;
  width: 100%;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 1.5rem;
  grid-template-columns: 1fr 1fr 1fr;
  border-bottom: 1px solid rgba(82, 82, 82, 0.64);
  padding-bottom: 1rem;

  span {
    h4 {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.375rem;
      color: var(--grey-100);
    }

    input {
      background-color: transparent;
      height: 0.5rem;
      width: 10rem;
      padding: 0.5rem 0;
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      color: var(--white);
      margin-top: 0.25rem;
    }

    button {
      color: var(--black-100);
      background-color: var(--primary);
      border-radius: 4px;
      width: 4rem;
      height: 2rem;
      font-weight: 600;
      font-size: 14px;
      margin-top: 0.5rem;
      transition: filter 0.4s;

      &:hover {
        filter: brightness(70%);
      }
    }

    p {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      color: var(--white);
      margin-top: 0.25rem;
    }
  }
`;

export const AddressInfo = styled.div`
  margin-top: 1.5rem;

  h3 {
    display: flex;
    align-items: center;

    img {
      margin-right: 1rem;
    }
  }

  h4 {
    font-size: 14px;
    color: #b8b8b8;
    margin-top: 1.5rem;
  }

  p {
    margin-top: 4px;
  }
`;
